import http from '../../http'
export default {
    getChannel: (data) => {
        return http.post('activityservice/channelsetup/list', data)
    },
    addChannel: (data) => {
        return http.post('activityservice/channelsetup/insert', data)
    },
    updateChannel: (data) => {
        return http.post('activityservice/channelsetup/update', data)
    },
    add: (data) => {
        return http.post('activityservice/ticketmanage/save', data)
    },
    update: (data) => {
        return http.post('activityservice/ticketmanage/update', data)
    },
    del: (data) => {
        return http.post('activityservice/ticketmanage/remove', data)
    },
    list: (params) => {
        return http.get('activityservice/ticketmanage/list', params)
    },
    get: (params) => {
        return http.get('activityservice/ticketmanage/get', params)
    }
}
